<template>
  <div v-loading.body="loading" element-loading-text="加载中..." class="app-container">
    <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
      <template slot="header">
        <el-tabs v-model="queryParams.paneType" @tab-click="handleFilter">
          <el-tab-pane v-for="(item, index) in panes" :key="index" :label="item.label" :name="item.name" />
        </el-tabs>
      </template>

      <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell style1">
        <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
          <template slot-scope="scope">
            <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" prop="payTime" width="140" align="center" />
        <el-table-column label="商品名称" prop="goodsName" min-width="250" />
        <el-table-column label="订单号" prop="orderNumber" width="220" align="center" />
        <el-table-column label="规格" prop="specification" />
        <el-table-column label="数量" prop="skuCount" align="right" width="60" />
        <el-table-column label="供货价" prop="stockPrice" align="right" width="70" />
        <el-table-column label="销售价" prop="retailPrice" align="right" width="70" />
        <el-table-column label="纯积分" prop="point" align="right" width="70" />
        <el-table-column label="积分+现金" prop="pointPrice" align="right" width="80" />
        <el-table-column label="纯现金" prop="retailPrice" align="right" width="70" />
        <el-table-column label="品牌方" prop="supplierName" />
        <el-table-column label="法人" />
        <el-table-column label="营业执照" />
        <el-table-column label="开户银行" />
        <el-table-column label="地址" />
        <el-table-column label="联系电话" />
        <el-table-column label="资质证件" />
        <el-table-column label="门头照" />
      </el-table>
      <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
    </el-card>
  </div>
</template>

<script>
import { getOrderTransactionRecords, exportOrderTransactionRecords } from '@/api/finance'
import { StickyHeader } from '@cell-x/el-table-sticky'

export default {
  name: 'LedgerEntry',
  components: {
    Pagination: () => import('@/components/Pagination')
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      panes: [
        { name: 'product', label: '产品信息' },
        { name: 'revenue', label: '收入信息' },
        { name: 'expense', label: '支出信息' }
      ],
      queryParams: {
        page: 1,
        limit: 20,
        paneType: 'product'
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      getOrderTransactionRecords(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).finally(() => {
        this.$util.delay(500).then(() => { this.loading = false })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
